"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["disabled", "aria-label"];
const _hoisted_2 = {
    key: 0,
    class: "recording-counter"
};
const vue_3 = require("vue");
const useVoiceToText_1 = require("./useVoiceToText");
const i18n_1 = require("../../../i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'VoiceToTextButton',
    props: {
        userId: {},
        disabled: { type: Boolean, default: false }
    },
    emits: ["transcript", "error-message", "active-change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { isRecording, isActive, recordingSeconds, errorMessage, toggleRecording, } = (0, useVoiceToText_1.useVoiceToText)({
            userId: props.userId,
            language: i18n_1.pageLocale,
            onTranscript: text => emit('transcript', text),
        });
        const voiceInputButtonClass = (0, vue_3.computed)(() => ({
            recording: isRecording.value,
            loading: isActive.value && !isRecording.value,
            'disabled-btn': props.disabled,
        }));
        (0, vue_3.watch)(errorMessage, message => emit('error-message', message));
        (0, vue_3.watch)(isActive, active => emit('active-change', active));
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                type: "button",
                class: (0, vue_2.normalizeClass)(["voice-input-btn", voiceInputButtonClass.value]),
                disabled: __props.disabled || ((0, vue_2.unref)(isActive) && !(0, vue_2.unref)(isRecording)),
                "aria-label": (0, vue_2.unref)(isRecording) ? '録音を停止' : '音声入力を開始',
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ((0, vue_2.unref)(toggleRecording) && (0, vue_2.unref)(toggleRecording)(...args)))
            }, [
                (0, vue_2.createElementVNode)("i", {
                    class: (0, vue_2.normalizeClass)((0, vue_2.unref)(isRecording) ? 'zmdi zmdi-stop' : 'zmdi zmdi-mic')
                }, null, 2 /* CLASS */),
                ((0, vue_2.unref)(isRecording))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(recordingSeconds)) + " / 60秒", 1 /* TEXT */))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
